// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-shell {
  min-height: 100vh;
  background: #f5f1e9;
  color: #4e3f3a;
  font-family: 'Roboto', system-ui, sans-serif;
}

.admin-nav {
  background: #fff;
  border-bottom: 1px solid #e8e4df;
  position: sticky;
  top: 0;
  z-index: 20;
}

.admin-nav-inner {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0.85rem 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.admin-nav-brand {
  font-family: 'Neucha', cursive;
  font-size: 1.35rem;
  color: #4e3f3a;
  text-decoration: none;
  white-space: nowrap;
}

.admin-nav-logout {
  border: 1px solid #e8e4df;
  background: #fff;
  border-radius: 8px;
  padding: 0.4rem 0.9rem;
  cursor: pointer;
  color: #4e3f3a;
}

.admin-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 1.75rem 24px 2.75rem;
}

.admin-header {
  margin-bottom: 1.5rem;
}

.admin-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
}

.admin-page-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.admin-back {
  display: inline-block;
  margin-bottom: 0.35rem;
  color: #6b5d58;
  text-decoration: none;
  font-size: 0.875rem;
}

.admin-title {
  margin: 0 0 0.25rem;
  font-family: 'Neucha', cursive;
  font-size: 1.85rem;
  font-weight: 400;
}

.admin-subtitle {
  margin: 0;
  color: #6b5d58;
  font-size: 0.9375rem;
}

.admin-dashboard {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.25rem;
}

@media (max-width: 1100px) {
  .admin-dashboard {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .admin-dashboard {
    grid-template-columns: 1fr;
  }
}

.admin-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 160px;
  background: #fff;
  border: 1px solid #e8e4df;
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.06);
}

.admin-card:hover {
  border-color: #d8cfc4;
  box-shadow: 0 6px 20px rgba(78, 63, 58, 0.1);
}

.admin-card h2 {
  margin: 0 0 0.45rem;
  font-size: 1.4rem;
  font-weight: 500;
}

.admin-card p {
  margin: 0;
  color: #6b5d58;
  font-size: 0.95rem;
  line-height: 1.4;
}

.admin-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: center;
  margin-bottom: 0.9rem;
}

.admin-toolbar input,
.admin-toolbar select {
  min-width: 180px;
}

.admin-count {
  margin-left: auto;
  color: #6b5d58;
  font-size: 0.875rem;
}

.admin-input,
.admin-select,
.admin-textarea {
  width: 100%;
  border: 1px solid #e8e4df;
  border-radius: 8px;
  padding: 0.45rem 0.65rem;
  font: inherit;
  color: inherit;
  background: #fff;
}

.admin-textarea {
  min-height: 80px;
  resize: vertical;
}

.admin-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0.75rem;
}

.admin-field label {
  font-size: 0.8125rem;
  color: #6b5d58;
}

.admin-field-hint {
  font-size: 0.75rem;
  color: #8a7c76;
}

.admin-check {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0.35rem 0;
}

.admin-check-list {
  max-height: 240px;
  overflow: auto;
  border: 1px solid #e8e4df;
  border-radius: 8px;
  padding: 0.5rem 0.65rem;
  background: #faf9f7;
}

.admin-btn {
  border: 1px solid #e8e4df;
  background: #fff;
  border-radius: 8px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  color: #4e3f3a;
  font: inherit;
}

.admin-btn:disabled {
  opacity: 0.55;
  cursor: default;
}

.admin-btn-primary {
  background: #fc761f;
  border-color: #fc761f;
  color: #fff;
}

.admin-btn-danger {
  color: #9b2c2c;
  border-color: #f0cfcf;
}

.admin-btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.admin-table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e8e4df;
  border-radius: 12px;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.admin-table th,
.admin-table td {
  padding: 0.7rem 0.8rem;
  text-align: left;
  border-bottom: 1px solid #f0ece6;
  vertical-align: middle;
}

.admin-table th {
  font-weight: 500;
  color: #6b5d58;
  background: #faf9f7;
}

.admin-table tr:last-child td {
  border-bottom: 0;
}

.admin-thumb {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  background: #f0ece6;
}

.admin-empty {
  margin: 1rem 0 0;
  color: #6b5d58;
}

.admin-badge {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: #f0ece6;
  font-size: 0.75rem;
  margin: 0 0.15rem 0.15rem 0;
}

.admin-badge-root {
  background: #f8d7da;
  color: #842029;
}

.admin-badge-admin {
  background: #dbeafe;
  color: #1e3a5f;
}

.admin-switch {
  width: 2.4rem;
  height: 1.3rem;
  appearance: none;
  background: #d8cfc4;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
}

.admin-switch:checked {
  background: #fc761f;
}

.admin-switch::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 1rem;
  height: 1rem;
  background: #fff;
  border-radius: 50%;
}

.admin-switch:checked::after {
  left: 1.05rem;
}

.admin-pagination {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.9rem;
}

.admin-pagination button,
.admin-pagination-ellipsis {
  min-width: 2rem;
  border: 1px solid #e8e4df;
  background: #fff;
  border-radius: 6px;
  padding: 0.25rem 0.45rem;
  cursor: pointer;
  color: inherit;
}

.admin-pagination button.is-active {
  background: #4e3f3a;
  color: #fff;
  border-color: #4e3f3a;
}

.admin-pagination button:disabled {
  opacity: 0.45;
  cursor: default;
}

.admin-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(40, 32, 28, 0.4);
  z-index: 40;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 4vh 16px;
  overflow: auto;
}

.admin-modal {
  width: min(560px, 100%);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 16px 48px rgba(40, 32, 28, 0.2);
}

.admin-modal--wide {
  width: min(760px, 100%);
}

.admin-modal-head,
.admin-modal-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1.1rem;
}

.admin-modal-head {
  border-bottom: 1px solid #f0ece6;
}

.admin-modal-head h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 500;
}

.admin-modal-body {
  padding: 1rem 1.1rem;
}

.admin-modal-foot {
  border-top: 1px solid #f0ece6;
  justify-content: flex-end;
}

.admin-icon-btn {
  border: 0;
  background: transparent;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  color: #6b5d58;
}

.admin-toasts {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: min(360px, calc(100vw - 32px));
}

.admin-toast {
  border-radius: 10px;
  padding: 0.7rem 0.9rem;
  box-shadow: 0 8px 24px rgba(40, 32, 28, 0.16);
  background: #fff;
}

.admin-toast--success {
  border-left: 4px solid #2f9e44;
}

.admin-toast--danger {
  border-left: 4px solid #c92a2a;
}

.admin-toast--warning {
  border-left: 4px solid #f59f00;
}

.admin-toast--info {
  border-left: 4px solid #1c7ed6;
}

.admin-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

@media (max-width: 900px) {
  .admin-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.admin-kpi {
  background: #fff;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  padding: 1rem 1.1rem;
}

.admin-kpi span {
  display: block;
  color: #6b5d58;
  font-size: 0.8rem;
}

.admin-kpi strong {
  font-size: 1.25rem;
}

.admin-chart-wrap {
  background: #fff;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  margin-bottom: 1rem;
  padding: 0.75rem 0.75rem 0.6rem;
}

.admin-chart-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.admin-chart-seg {
  display: inline-flex;
  border: 1px solid #e8e4df;
  border-radius: 8px;
  overflow: hidden;
}

.admin-chart-seg button {
  border: 0;
  background: #fff;
  padding: 0.38rem 0.75rem;
  cursor: pointer;
  color: #4e3f3a;
  font-size: 0.8125rem;
}

.admin-chart-seg button + button {
  border-left: 1px solid #e8e4df;
}

.admin-chart-seg button.is-active {
  background: #4e3f3a;
  color: #fff;
}

.admin-chart-toolbar .admin-select {
  width: auto;
  min-width: 180px;
}

.admin-chart {
  width: 100%;
  height: 380px;
}

.admin-media-preview {
  max-width: 160px;
  max-height: 90px;
  border-radius: 8px;
}

.admin-error {
  color: #9b2c2c;
  font-size: 0.875rem;
  margin: 0 0 0.75rem;
}

.admin-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

@media (max-width: 640px) {
  .admin-row-2,
  .admin-kpis {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Admin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".admin-shell {\n  min-height: 100vh;\n  background: #f5f1e9;\n  color: #4e3f3a;\n  font-family: 'Roboto', system-ui, sans-serif;\n}\n\n.admin-nav {\n  background: #fff;\n  border-bottom: 1px solid #e8e4df;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.admin-nav-inner {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 0.85rem 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.admin-nav-brand {\n  font-family: 'Neucha', cursive;\n  font-size: 1.35rem;\n  color: #4e3f3a;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.admin-nav-logout {\n  border: 1px solid #e8e4df;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.4rem 0.9rem;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.admin-container {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 1.75rem 24px 2.75rem;\n}\n\n.admin-header {\n  margin-bottom: 1.5rem;\n}\n\n.admin-page-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n}\n\n.admin-page-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.admin-back {\n  display: inline-block;\n  margin-bottom: 0.35rem;\n  color: #6b5d58;\n  text-decoration: none;\n  font-size: 0.875rem;\n}\n\n.admin-title {\n  margin: 0 0 0.25rem;\n  font-family: 'Neucha', cursive;\n  font-size: 1.85rem;\n  font-weight: 400;\n}\n\n.admin-subtitle {\n  margin: 0;\n  color: #6b5d58;\n  font-size: 0.9375rem;\n}\n\n.admin-dashboard {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n@media (max-width: 1100px) {\n  .admin-dashboard {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .admin-dashboard {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 160px;\n  background: #fff;\n  border: 1px solid #e8e4df;\n  border-radius: 16px;\n  padding: 1.75rem 1.5rem;\n  text-decoration: none;\n  color: inherit;\n  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.06);\n}\n\n.admin-card:hover {\n  border-color: #d8cfc4;\n  box-shadow: 0 6px 20px rgba(78, 63, 58, 0.1);\n}\n\n.admin-card h2 {\n  margin: 0 0 0.45rem;\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.admin-card p {\n  margin: 0;\n  color: #6b5d58;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.admin-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  align-items: center;\n  margin-bottom: 0.9rem;\n}\n\n.admin-toolbar input,\n.admin-toolbar select {\n  min-width: 180px;\n}\n\n.admin-count {\n  margin-left: auto;\n  color: #6b5d58;\n  font-size: 0.875rem;\n}\n\n.admin-input,\n.admin-select,\n.admin-textarea {\n  width: 100%;\n  border: 1px solid #e8e4df;\n  border-radius: 8px;\n  padding: 0.45rem 0.65rem;\n  font: inherit;\n  color: inherit;\n  background: #fff;\n}\n\n.admin-textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.admin-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin-bottom: 0.75rem;\n}\n\n.admin-field label {\n  font-size: 0.8125rem;\n  color: #6b5d58;\n}\n\n.admin-field-hint {\n  font-size: 0.75rem;\n  color: #8a7c76;\n}\n\n.admin-check {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0.35rem 0;\n}\n\n.admin-check-list {\n  max-height: 240px;\n  overflow: auto;\n  border: 1px solid #e8e4df;\n  border-radius: 8px;\n  padding: 0.5rem 0.65rem;\n  background: #faf9f7;\n}\n\n.admin-btn {\n  border: 1px solid #e8e4df;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.4rem 0.8rem;\n  cursor: pointer;\n  color: #4e3f3a;\n  font: inherit;\n}\n\n.admin-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.admin-btn-primary {\n  background: #fc761f;\n  border-color: #fc761f;\n  color: #fff;\n}\n\n.admin-btn-danger {\n  color: #9b2c2c;\n  border-color: #f0cfcf;\n}\n\n.admin-btn-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.admin-table-wrap {\n  overflow-x: auto;\n  background: #fff;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.admin-table th,\n.admin-table td {\n  padding: 0.7rem 0.8rem;\n  text-align: left;\n  border-bottom: 1px solid #f0ece6;\n  vertical-align: middle;\n}\n\n.admin-table th {\n  font-weight: 500;\n  color: #6b5d58;\n  background: #faf9f7;\n}\n\n.admin-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.admin-thumb {\n  width: 44px;\n  height: 44px;\n  object-fit: cover;\n  border-radius: 8px;\n  background: #f0ece6;\n}\n\n.admin-empty {\n  margin: 1rem 0 0;\n  color: #6b5d58;\n}\n\n.admin-badge {\n  display: inline-block;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  background: #f0ece6;\n  font-size: 0.75rem;\n  margin: 0 0.15rem 0.15rem 0;\n}\n\n.admin-badge-root {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.admin-badge-admin {\n  background: #dbeafe;\n  color: #1e3a5f;\n}\n\n.admin-switch {\n  width: 2.4rem;\n  height: 1.3rem;\n  appearance: none;\n  background: #d8cfc4;\n  border-radius: 999px;\n  position: relative;\n  cursor: pointer;\n}\n\n.admin-switch:checked {\n  background: #fc761f;\n}\n\n.admin-switch::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 1rem;\n  height: 1rem;\n  background: #fff;\n  border-radius: 50%;\n}\n\n.admin-switch:checked::after {\n  left: 1.05rem;\n}\n\n.admin-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.9rem;\n}\n\n.admin-pagination button,\n.admin-pagination-ellipsis {\n  min-width: 2rem;\n  border: 1px solid #e8e4df;\n  background: #fff;\n  border-radius: 6px;\n  padding: 0.25rem 0.45rem;\n  cursor: pointer;\n  color: inherit;\n}\n\n.admin-pagination button.is-active {\n  background: #4e3f3a;\n  color: #fff;\n  border-color: #4e3f3a;\n}\n\n.admin-pagination button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.admin-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(40, 32, 28, 0.4);\n  z-index: 40;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 4vh 16px;\n  overflow: auto;\n}\n\n.admin-modal {\n  width: min(560px, 100%);\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 16px 48px rgba(40, 32, 28, 0.2);\n}\n\n.admin-modal--wide {\n  width: min(760px, 100%);\n}\n\n.admin-modal-head,\n.admin-modal-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.9rem 1.1rem;\n}\n\n.admin-modal-head {\n  border-bottom: 1px solid #f0ece6;\n}\n\n.admin-modal-head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n\n.admin-modal-body {\n  padding: 1rem 1.1rem;\n}\n\n.admin-modal-foot {\n  border-top: 1px solid #f0ece6;\n  justify-content: flex-end;\n}\n\n.admin-icon-btn {\n  border: 0;\n  background: transparent;\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #6b5d58;\n}\n\n.admin-toasts {\n  position: fixed;\n  right: 16px;\n  bottom: 16px;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-width: min(360px, calc(100vw - 32px));\n}\n\n.admin-toast {\n  border-radius: 10px;\n  padding: 0.7rem 0.9rem;\n  box-shadow: 0 8px 24px rgba(40, 32, 28, 0.16);\n  background: #fff;\n}\n\n.admin-toast--success {\n  border-left: 4px solid #2f9e44;\n}\n\n.admin-toast--danger {\n  border-left: 4px solid #c92a2a;\n}\n\n.admin-toast--warning {\n  border-left: 4px solid #f59f00;\n}\n\n.admin-toast--info {\n  border-left: 4px solid #1c7ed6;\n}\n\n.admin-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 900px) {\n  .admin-kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.admin-kpi {\n  background: #fff;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n}\n\n.admin-kpi span {\n  display: block;\n  color: #6b5d58;\n  font-size: 0.8rem;\n}\n\n.admin-kpi strong {\n  font-size: 1.25rem;\n}\n\n.admin-chart-wrap {\n  background: #fff;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  margin-bottom: 1rem;\n  padding: 0.75rem 0.75rem 0.6rem;\n}\n\n.admin-chart-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.admin-chart-seg {\n  display: inline-flex;\n  border: 1px solid #e8e4df;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.admin-chart-seg button {\n  border: 0;\n  background: #fff;\n  padding: 0.38rem 0.75rem;\n  cursor: pointer;\n  color: #4e3f3a;\n  font-size: 0.8125rem;\n}\n\n.admin-chart-seg button + button {\n  border-left: 1px solid #e8e4df;\n}\n\n.admin-chart-seg button.is-active {\n  background: #4e3f3a;\n  color: #fff;\n}\n\n.admin-chart-toolbar .admin-select {\n  width: auto;\n  min-width: 180px;\n}\n\n.admin-chart {\n  width: 100%;\n  height: 380px;\n}\n\n.admin-media-preview {\n  max-width: 160px;\n  max-height: 90px;\n  border-radius: 8px;\n}\n\n.admin-error {\n  color: #9b2c2c;\n  font-size: 0.875rem;\n  margin: 0 0 0.75rem;\n}\n\n.admin-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n@media (max-width: 640px) {\n  .admin-row-2,\n  .admin-kpis {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
